import React, { useContext, useEffect, useState } from "react";
import InputDateRang from "../InputDateRang";
import moment from "moment";
import { action, API, controller } from "../../../api/api";
import { ToFormData } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import Export from "../../../layout/Export";

const Header = ({ setValues }) => {
  const { authUser } = useContext(AppContext);
  const [sortDate, setSortDate] = useState({
    fromDate: new Date(moment().startOf("month").toDate()),
    toDate: new Date(moment().endOf("month").toDate()),
  });

  useEffect(() => {
    if (authUser && sortDate) {
      API(controller.Report + action.ProfitAndLoss).post(
        ToFormData({
          fromDate: new Date(sortDate.fromDate).toISOString(),
          toDate: new Date(sortDate.toDate).toISOString(),
        }),
        (res) => res.status === 200 && setValues({ ...res.result })
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortDate, authUser]);

  return (
    <div className="flex flex-wrap gap-3 justify-between items-center bg-white p-[8px] rounded-[20px]">
      {/* Label */}
      <div>
        <span className="text-[20px] uppercase font-medium text-gray-600 pl-[3px]">
          📊Profit & Loss Report
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        <InputDateRang {...{ sortDate, setSortDate }} />

        <Export
          endpoint={controller.Report + action.ExportProfitAndLoss}
          date={sortDate}
        />
      </div>
    </div>
  );
};

export default Header;
